import React, {PureComponent, ReactNode} from 'react';
import {isDesktop, isGuest} from 'app/utils';
import {SignInButton} from 'app/components/auth/SignInButton';
import SpriteIcon from 'app/utils/sprites/SpriteIcon';

interface PropsInterface {
    isActive: boolean
    message: string
    handleOnClick: (e: React.MouseEvent) => void
}

export default class ButtonBellWithMessage extends PureComponent<PropsInterface> {
    renderSvg = (): ReactNode => <SpriteIcon name="#svg-notification-bell-transparent" className="svg-default"/>;


    render(): ReactNode {
        const {isActive, message, handleOnClick} = this.props;
        return <div className="subscription-container giveaway-subscription">
            {isDesktop() && <div className="subscription-description">
                <div className="subscription-description__inner">
                    <p>{message}</p>
                </div>
            </div>}
            {isGuest()
                ? <SignInButton className="button-subscription" usingOnTab={'GIVEAWAY-BELL'}>
                    {this.renderSvg()}
                </SignInButton>
                : <button className={`button-subscription${isActive ? ' active' : ''}`} onClick={handleOnClick}>
                    {this.renderSvg()}
                </button>}
        </div>;
    }
}
